import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useEffect, useState } from "react";
import { AuthenticationStatus } from "../store/slices/authSlice";
import branch from "branch-sdk";
import { useWallet } from "../hooks/useWallet";
import { useStream } from "../hooks/useStream";

export const setAppBadge = (count: number) => {
    document.title = `${count > 0 ? `(${count}) ` : ''}Orange Pill App | Web App`;
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if(favicon) {
        favicon.href = count > 0 ? `/favicon_with_dot.png` : '/favicon.png';
    }
}

export const RedirectHandler = () => {
    const [pathnameToRedirectOnLogin, setPathnameToRedirectOnLogin] = useState<string | null>(null);
    const { status } = useAuth();
    const { nbUnread } = useStream();
    const location = useLocation();
    const navigate = useNavigate();
    const {nbTxUnread} = useWallet();

    useEffect(() => {
        setAppBadge(nbTxUnread + nbUnread);
    }, [nbTxUnread, nbUnread]);

    useEffect(() => {
        branch.init(process.env.REACT_APP_BRANCH_KEY ?? '', undefined, () => {
            branch.data((error, data) => {
                if(data) {
                    const dataParsed = data.data_parsed as { kind: string, id: string };

                    if((dataParsed.kind === 'user' || dataParsed.kind === 'merchant') && dataParsed.id) {
                        setPathnameToRedirectOnLogin(`/home/chat/user/${dataParsed.id}`);
                        return;
                    } else if(dataParsed.kind === 'event' && dataParsed.id) {
                        setPathnameToRedirectOnLogin(`/home/search/event/${dataParsed.id}`);
                        return;
                    } else if(dataParsed.kind === 'group-chat' && dataParsed.id) {
                        setPathnameToRedirectOnLogin(`/home/chat/group/${dataParsed.id}`);
                        return;
                    }
                }

                setPathnameToRedirectOnLogin('');
                return;
            })
        });
    }, []);

    useEffect(() => {
        if(pathnameToRedirectOnLogin !== null) {
            if (
                !location.pathname.startsWith('/login') && 
                status !== AuthenticationStatus.AUTHENTICATED
            ) {
                if(pathnameToRedirectOnLogin === '' && location.pathname.startsWith('/home')) {
                    setPathnameToRedirectOnLogin(location.pathname);
                }
                navigate('/login');
            } else {
                let shouldRedirect = (
                    !location.pathname.startsWith('/home') || 
                    location.pathname === '/home' ||
                    location.pathname === '/home/'
                ) && status === AuthenticationStatus.AUTHENTICATED;

                if(location.pathname.startsWith('/login') && location.state?.addAccount)
                    shouldRedirect = false;

                if(shouldRedirect) {
                    if(pathnameToRedirectOnLogin && pathnameToRedirectOnLogin !== '') {
                        navigate(pathnameToRedirectOnLogin);
                    } else {
                        navigate('/home/chat');
                    }
                }
            }
        }
    }, [location, pathnameToRedirectOnLogin, status]);

  return null;
}

